import { keyframes } from 'styled-components';

/**
 * Rotate element 360deg
 * for example in animation loading
 */
const Opacity = keyframes`
   0% {
		opacity: 0;
	}
	100% {
		opacity: 1;	
	}
`;

export default Opacity;
